import { useLocaleStore } from './store';
import { useT } from './useT';
import { useFormatNumber, useFormatDate, useFormatMoney, useFormatRelativeTime, pickLocaleName, pickLocaleString, resolveLocaleText } from './format';
import { queryClient } from '@/api/queryClient';

export { useT, useFormatNumber, useFormatDate, useFormatMoney, useFormatRelativeTime, useLocaleStore, pickLocaleName, pickLocaleString, resolveLocaleText };
export type { Locale, Namespace } from './locales/_index';

export const useLocale = () => useLocaleStore((s) => s.locale);
export const useSetLocale = () => useLocaleStore((s) => s.setLocale);

// Seed from the store's *current* value so the first user-driven locale
// change (the previous code's `!== undefined` guard skipped this one) is
// caught and the cache is invalidated. The subscription registers after
// Zustand's sync persist hydration, so getState() already reflects the
// hydrated locale.
let lastLocale = useLocaleStore.getState().locale;
useLocaleStore.subscribe((state) => {
  if (state.locale === lastLocale) return;
  lastLocale = state.locale;
  queryClient.invalidateQueries();
});
